import { InjectionToken } from '@angular/core';

export interface TitledUrl {
  url: string;
  title: string;
}

export interface ProgramTabUrls {
  urls: { [key: string]: TitledUrl };
  name: string;
}

export interface ProgramLinkUrls {
  urls: { [key: string]: TitledUrl };
}

export interface AdvertisementPageIds {
  de: number;
  en: number;
}

export interface AdvertisementFormats {
  phone: number;
  desktop: number;
}

export interface FairConfiguration {
  name: string;
  shortName?: string;
  hidden?: boolean;
  program?: {
    baseUrl: string;
    tabs: ProgramTabUrls[];
    links?: ProgramLinkUrls[];
  };
  hallplan?: HallplanConfig;
  timezone?: string;
  productAtBooth?: boolean;
  discoveryHidden?: boolean;
  startupFilter?: boolean;
  startDate?: Date;
  endDate?: Date;
  venue?: string;
  id?: string;
  advertisements: {
    parallax: {
      enabled: boolean;
      siteId?: number;
      pageIds?: AdvertisementPageIds;
      formats?: AdvertisementFormats;
    };
    skyscraper: {
      enabled: boolean;
      siteId?: number;
      pageIds?: AdvertisementPageIds;
      format?: number;
    };
  };
}

export type Url = string;

export type HallplanConfig = {
  baseUrl: Url;
  scriptUrl: Url;
  localizedUrls: { [key: string]: Url };
};

export interface FairsConfiguration {
  activeFair: string;
  bauInsights: string;
  fairs: {
    [key: string]: FairConfiguration;
  };
}

export interface LandingpageConfiguration {
  discoveryFairId: string;
  exhibitors: LandingpageConfigurationItem[];
  products: LandingpageConfigurationItem[];
  posts: LandingpageConfigurationItem[];
  defaultFilterChips: { label: { [key: string]: string }; filter: { [key: string]: string[] } }[];
}

export interface LandingpageConfigurationItem {
  id: string;
  fairId: string;
}

export const LANDINGPAGE_CONFIGURATION = new InjectionToken<LandingpageConfiguration>('LANDINGPAGE_CONFIGURATION');
export const FAIRS_CONFIGURATION = new InjectionToken<FairsConfiguration>('FAIRS_CONFIGURATION');
